function customHeight() {
  const sectionAcordion = document.querySelector(".section-accordions");

  if (!sectionAcordion || sectionAcordion.classList.contains("custom-height")) {
    return;
  }

  sectionAcordion.classList.add("custom-height");

  // gett= all accordions content
  const accordions = document.querySelectorAll(".accordion__inner");
  accordions.forEach((accordion) => {
    accordion.addEventListener("click", (e) => {
      // add open attribue to the accordion

      accordion.removeAttribute("open");
      var contentWrap = accordion.querySelector(".accordion__content");
      var accordionsContent = accordion.querySelector(".accordion__content p");
      var childElements = contentWrap.children;
      setTimeout(() => {
        // Calculate the total height of child elements
        var totalHeight = Array.from(childElements).reduce((acc, child) => {
          return acc + child.clientHeight;
        }, 0);

        accordion.classList.toggle("active");

        if (accordion.classList.contains("active")) {
          contentWrap.style.height = totalHeight + 100 + "px";
        } else {
          contentWrap.style.height = "0px";
        }
      }, 200);
    });
  });

  console.log("handleProductAccordions");
}

// function ProductAccordions() {
//   const sectionAcordion = document.querySelector(
//     ".main-product__details-wrapper"
//   );

//   if (!sectionAcordion || sectionAcordion.classList.contains("custom-height")) {
//     return;
//   }

//   sectionAcordion.classList.add("custom-height");

//   // gett= all accordions content
//   const accordions = sectionAcordion.querySelectorAll(".accordion__inner");
//   accordions.forEach((accordion) => {
//     var contentWrap1 = accordion.querySelector(".accordion__content");
//     contentWrap1.style.height = "auto";
//     accordion.addEventListener("click", (e) => {
//       // add open attribue to the accordion

//       accordion.removeAttribute("open");
//       var contentWrap = accordion.querySelector(".accordion__content");
//       var accordionsContent = accordion.querySelector(".accordion__content p");
//       var childElements = contentWrap.children;

//       // Calculate the total height of child elements
//       // var totalHeight = Array.from(childElements).reduce((acc, child) => {
//       //   console.log(child.clientHeight);
//       //   return acc + child.clientHeight;
//       // }, 0);
//       var totalHeight = Array.from(childElements).reduce((acc, child) => {
//         let rect = child.getBoundingClientRect();
//         return acc + rect.height;
//       }, 0);

//       accordion.classList.toggle("active");

//       if (accordion.classList.contains("active")) {
//         contentWrap.style.height = totalHeight + 75 + "px";
//       } else {
//         contentWrap.style.height = "0px";
//       }
//     });
//   });

//   console.log("handleProductAccordions");
// }

function ProductAccordions() {
  const sectionAcordion = document.querySelector(
    ".main-product__details-wrapper"
  );

  if (!sectionAcordion || sectionAcordion.classList.contains("custom-height")) {
    return;
  }

  sectionAcordion.classList.add("custom-height");

  const accordions = sectionAcordion.querySelectorAll(".accordion__inner");
  accordions.forEach((accordion) => {
    var contentWrap1 = accordion.querySelector(".accordion__content");
    contentWrap1.style.height = "auto";
    let wrapHeight = contentWrap1.getBoundingClientRect().height;
    accordion.classList.toggle("active");
    contentWrap1.style.height = wrapHeight + 75 + "px";

    accordion.addEventListener("click", (e) => {
      // add open attribue to the accordion

      accordion.removeAttribute("open");
      var contentWrap = accordion.querySelector(".accordion__content");
      var accordionsContent = accordion.querySelector(".accordion__content p");
      var childElements = contentWrap.children;

      var totalHeight = Array.from(childElements).reduce((acc, child) => {
        let rect = child.getBoundingClientRect();
        return acc + rect.height;
      }, 0);

      accordion.classList.toggle("active");

      if (accordion.classList.contains("active")) {
        contentWrap.style.height = wrapHeight + 75 + "px";
      } else {
        contentWrap.style.height = "0px";
      }
    });
  });

  console.log("handleProductAccordions");
}

customHeight();
ProductAccordions();

function customswatch() {
  const swatchWrap = document.querySelector(
    ".main-product__form-group.list-swatches"
  );

  const swatchcontrol = '';
  if (swatchWrap) {
    const swatchcontrol = swatchWrap.querySelectorAll(".swatch");
  }
  let item;

  const imageWrap = document.querySelector(
    ".main-product__media-list.splide__list"
  );

  const mobileImageWrap = document.querySelector(
    ".main-product__media-track.splide__track"
  );

  let checker = false;

  if (swatchcontrol) {
    swatchcontrol.forEach((swatch) => {
      swatch.addEventListener("click", (e) => {
        // get swatch innner content
        item = swatch.innerHTML;
        console.log(item);

        // search image inside the image wrap that has alt attribute equal to the swatch inner content
        let image = imageWrap.querySelector(`[alt="${item}"]`);

        if (!image) {
          return;
        }
        // change all images order to 0
        let theimagewrapper = imageWrap.querySelectorAll(
          "main-product__media-item"
        );

        let elementwrapper = imageWrap.querySelectorAll(".splide__slide");

        elementwrapper.forEach((elements) => {
          elements.style.order = "0";
        });

        if (window.innerWidth > 768) {
          console.log(image);

          theimagewrapper.forEach((elements) => {
            elements.closest(".main-product__media-item").style.order = "0";
          });
          // search the wrapper of the image main-product__media-item splide__slide
          let imageWrapper = image.closest(".main-product__media-item");
          console.log(imageWrapper);
          // set order to -1
          imageWrapper.style.order = "-1";

          swatchcontrol.forEach((swatch) => {
            swatch.classList.remove("active");
          });
          swatch.classList.add("active");
        } else {
          console.log("mobile");
          let index = 0;
          let splideitem = mobileImageWrap.querySelectorAll(".splide__slide");

          console.log(splideitem);
          splideitem.forEach((elements) => {
            elements.style.order = index;
            // set data-order attribute to elements
            elements.setAttribute("data-order", index);
            index++;
            console.log(elements);
          });

          let imageWrapper = image.closest(".splide__slide");
          let currentActive = mobileImageWrap.querySelector(
            ".splide__slide.is-active"
          );
          let currentActiveOrder = currentActive.getAttribute("data-order");
          console.log(currentActiveOrder);
          // set order to current active order
          currentActive.style.order = imageWrapper.getAttribute("data-order");
          imageWrapper.style.order = currentActiveOrder;

          if (!checker) {
            // watch this element main-product__media-list splide__list if there is a change do this
            var observer = new MutationObserver(function (mutations) {
              mutations.forEach(function (mutation) {
                //  revert all order to its original order
                let splideitem =
                  mobileImageWrap.querySelectorAll(".splide__slide");
                splideitem.forEach((elements) => {
                  elements.style.order = elements.getAttribute("data-order");
                });
              });
            });

            // configuration of the observer:
            var config = {
              attributes: true,
              childList: true,
              characterData: true,
            };

            // pass in the target node, as well as the observer options
            observer.observe(imageWrap, config);

            checker = true;
          }
        }
      });
    });
  }
}

customswatch();
